// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".R8p--PopoversLayer--PopoversLayer{position:absolute;z-index:var(--uikit-zIndex-popovers);left:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PopoversLayer": "R8p--PopoversLayer--PopoversLayer"
};
module.exports = ___CSS_LOADER_EXPORT___;
